/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TranslocoDirective } from '@jsverse/transloco';
import { UppercaseDirective } from 'src/app/directives/uppercase.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFieldComponent),
      multi: true
    },
    provideNgxMask()

  ],
  standalone: true,
  imports: [NzInputModule, NgxMaskDirective, UppercaseDirective, CommonModule, FormsModule, TranslocoDirective],
})
export class InputFieldComponent implements ControlValueAccessor {
  @ViewChild('myInput', { static: false }) myInput!: ElementRef;

  @Output() valueChange = new EventEmitter<any>();
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() prefix: string = '';
  @Input() thousandSeparator: string = ''
  @Input() type: string = 'text'
  @Input() validator: object = {};
  @Input() disabled = false
  @Input() isCapitalRequired = false
  @Input() dropSpecialCharacters = false
  @Input() remark: string = '';
  @Input() showRemarks = false
  @Input() maxLenght = null
  @Input() mask = ''
  @Input() borderRadius = '8px'



  @Input() style: string = 'margin-bottom: 20px;'


  value: any = '';

  // Handle input change
  onInput(event: any) {
    this.validator = {}
    this.value = event.target.value;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  // Write value to model
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  // Register onChange method
  onChange: (value: any) => void = () => { };

  // Register onTouched method
  onTouched: () => void = () => { };

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  moveCursorToEnd() {
    const inputEl = this.myInput.nativeElement;

    const length = inputEl.value.length;
    inputEl.setSelectionRange(length, length);

  }

  enforceMaxLength(event: any) {
    if (this.maxLenght !== null && event.target.value.length > this.maxLenght) {
      event.target.value = event.target.value.slice(0, this.maxLenght);
    }
  }


}
